import { Record, List, fromJS } from 'immutable';
import Location, { Locations } from 'records/Location';
import { BRAND_PROPERTIES } from 'constants/brand';

export const DEFAULT_COLORS = {
  HEX: '#eee',
  RGB: {
    a: 1,
    b: 238,
    g: 238,
    r: 238,
  },
};

const contentFile = {
  contentName: 'Default Logo',
  contentUrl: null,
  createBy: 0,
  createTime: null,
  description: 'The current Brand Logo',
  dimensions: [
    {
      length: 0,
      units: 0,
      width: 0,
    },
  ],
  id: 0,
  sizes: [
    {
      size: 0,
      type: 0,
      units: 0,
    },
  ],
};

const colors = [
  {
    colorName: 'accentColor1',
    colorValue: {
      hex: DEFAULT_COLORS.HEX,
      rgb: DEFAULT_COLORS.RGB,
    },
  },
  {
    colorName: 'accentColor2',
    colorValue: {
      hex: DEFAULT_COLORS.HEX,
      rgb: DEFAULT_COLORS.RGB,
    },
  },
  {
    colorName: 'accentColor3',
    colorValue: {
      hex: DEFAULT_COLORS.HEX,
      rgb: DEFAULT_COLORS.RGB,
    },
  },
];

const urls = [
  {
    urlTypeTextKey: 'http',
    urlAddress: '',
  },
];

const defaultValues = {
  id: null,
  brandName: '',
  foodTypeId: null,
  businessTypeId: null,
  businessTypeName: '',
  description: '',
  colorSource: 'rgb',
  contentFile: fromJS(contentFile),
  file: null,
  colors: fromJS(colors),
  urls: fromJS(urls),
  locations: Locations(),
  brandProperties: {},
};

export default class Brand extends Record(defaultValues, Brand) {
  constructor(values) {
    super({
      ...values,
      contentFile: values && values.contentFile
                    ? fromJS(values.contentFile) : defaultValues.contentFile,
      colors: values && values.colors
                ? fromJS(values.colors) : defaultValues.colors,
      urls: values && values.urls
              ? fromJS(values.urls) : defaultValues.urls,
      locations: values && values.locations
            ? Locations(values.locations) : defaultValues.locations,
    });
  }

  findColorByName(colorName) {
    const brandColors = this.get('colors');
    return brandColors.find((color) => {
      return color.get('colorName') === colorName ? color : undefined;
    });
  }

  findColorIndexByName(colorName) {
    const brandColors = this.get('colors');
    return brandColors.findIndex((color) => {
      return color.get('colorName') === colorName ? color : undefined;
    });
  }

  getDefaultLocation() {
    return this.get('locations').first();
  }

  static getCurrentUserBrand(userBrands) {
    return userBrands.first();
  }

  static addUserBrand(userBrands, brand) {
    return userBrands.push(brand);
  }

  static getBrandIndexById(userBrands, brandId) {
    return userBrands.findIndex((userBrand) => {
      return userBrand.get('id') === brandId ? userBrand : undefined;
    });
  }

  static getBrandById(userBrands, brandId) {
    return userBrands.find((userBrand) => {
      return userBrand.get('id') === brandId ? userBrand : undefined;
    });
  }

  static updateUserBrands(userBrands, brand) {
    const id = brand.get('id');
    const index = Brand.getBrandIndexById(userBrands, id);
    return userBrands.set(index, brand);
  }

  static updateUserBrandsLocation(userBrands, location) {
    const brandId = location.get('brandId');
    const locationId = location.get('id');
    const brand = Brand.getBrandById(userBrands, brandId);
    const brandIndex = Brand.getBrandIndexById(userBrands, brandId);

    let brandLocations = brand.get('locations');
    const locationIndex = Location.findLocatioIndexById(brandLocations, locationId);
    brandLocations = brandLocations.set(locationIndex, location);
    return userBrands.setIn([brandIndex, 'locations'], brandLocations);
  }

  static addUserBrandLocation(userBrands, location) {
    const brandId = location.get('brandId');
    const brand = Brand.getBrandById(userBrands, brandId);
    const brandIndex = Brand.getBrandIndexById(userBrands, brandId);

    let locations = brand.get('locations');
    locations = locations.push(location);
    return userBrands.setIn([brandIndex, 'locations'], locations);
  }

  static addUserBrandProperty(userBrands, brandProperty) {
    const brand = Brand.getBrandById(userBrands, brandProperty.brandId);
    const brandIndex = Brand.getBrandIndexById(userBrands, brandProperty.brandId);

    const brandProps = { ...brand.get('brandProperties') };
    brandProps[BRAND_PROPERTIES.GLOBAL_PRICE_EFFECTIVE_DATE] = brandProperty;
    return userBrands.setIn([brandIndex, 'brandProperties'], brandProps);
  }

  static removeUserBrandProperty(userBrands, brandProperty) {
    const brand = Brand.getBrandById(userBrands, brandProperty.brandId);
    const brandIndex = Brand.getBrandIndexById(userBrands, brandProperty.brandId);

    const brandProps = { ...brand.get('brandProperties') };
    delete brandProps[brandProperty.property];
    return userBrands.setIn([brandIndex, 'brandProperties'], brandProps);
  }

  static updateUserBrandProperty(userBrands, brandProperty) {

    const brand = Brand.getBrandById(userBrands, brandProperty.brandId);
    const brandIndex = Brand.getBrandIndexById(userBrands, brandProperty.brandId);

    const brandProps = { ...brand.get('brandProperties') };
    brandProps[brandProperty.propertyKey] = {
      ...brandProperty,
    }
    return userBrands.setIn([brandIndex, 'brandProperties'], brandProps);
  }
}

export const UserBrands = (data) => {
  let brands = new List();
  data.forEach((value) => {
    brands = brands.push(new Brand(value));
  });
  return brands;
};
